import classNames from 'clsx';
import type { ReactNode } from 'react';
import React from 'react';

import type { GameView } from '../../../types/common';

import styles from './GridListViewToggleButton.scss';

export interface Props {
  id: string;
  selected?: boolean;
  gameView: GameView;
  handleSelect(selected: GameView): void;
  classes?: {
    button?: string;
    active?: string;
  };
  icon: ReactNode;
}

const GridListViewToggleButton: React.FC<Props> = ({
  id,
  gameView,
  selected,
  handleSelect,
  classes,
  icon
}) => {
  const buttonClassName = [styles.button, classes?.button];
  const activeClassName = classNames(styles.active, classes?.active);

  return (
    <div
      data-testid={`${id}-${gameView}`}
      className={classNames(buttonClassName, {
        [activeClassName]: selected
      })}
      onClick={() => handleSelect(gameView)}
    >
      {icon}
    </div>
  );
};
export default GridListViewToggleButton;
